import React from 'react'

const RequiredStar = () => {
  return <span className="ml-1 text-red-500">*</span>
}

export default RequiredStar
